module.exports = __webpack_public_path__ + "static/media/keytrack.2b507a30.mp4";